import { CategoryTile } from '@akyga/shared-ui/CategoryTile';

export default CategoryTile;
